// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/build/onprem-release-25-4-2.202606261441/" + chunkId + ".chunk.js";
};